import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  number: '$1M',
  label: 'Sales in their first month'
}, {
  number: '$20M',
  label: 'On pace for 2025'
}, {
  number: '$200M',
  label: 'Five-year goal'
}, {
  number: '4',
  label: 'Offices and growing'
}];
export function StatsBand() {
  return <section className="py-20 bg-off-white" data-id="element-128">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-130">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center" data-id="element-131">
              <div className="font-display text-5xl sm:text-6xl lg:text-7xl text-maroon mb-2" data-id="element-132">
                {stat.number}
              </div>
              <div className="text-gray-700 font-medium text-sm sm:text-base" data-id="element-133">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}